import React, {Component} from "react";
import Paper from 'material-ui/Paper';
import { Col } from 'react-flexbox-grid';

import "../../App.css";


class ChapterSummary extends Component {
    render() {
        return (
            <Col xs={12} sm={6} md={4}>
                <Paper className="chapterContainer" zDepth={1} style={{backgroundImage: `url(${this.props.img})`}} >
                    <h1 className="chapterTitle">
                        {this.props.title}
                        </h1>
                    <h1 className="chapterSubTitle">{this.props.subtitle}</h1>
                    <h1 className="chapterSubSubTitle">{this.props.subsubtitle}</h1>
                    <p className="chapterDescription">
                        {this.props.children}
                    </p>
                </Paper>
            </Col>
        );
    }
}

export default ChapterSummary;



// WEBPACK FOOTER //
// ./src/components/ChapterSummary/ChapterSummary.js